export default {
  queriedLabels: state => {
    return state.queriedLabels
  }
}
